exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipe-card .card-content[data-v-535c223e] {\n  padding: 15px;\n  height: 80px;\n}\n.recipe-card .card-content h5[data-v-535c223e] {\n  margin-top: 0;\n}\n.recipe-card .card-content .recipe-detail[data-v-535c223e] {\n  font-size: 12px;\n  padding: 0 5px;\n  text-align: center;\n}\n.recipe-card .card-product[data-v-535c223e] {\n  position: absolute;\n  bottom: 0;\n  background-color: #fff;\n  left: 0;\n  padding: 10px;\n  border-top-right-radius: 20px;\n}", ""]);

// exports
